import { IActivityTypes } from '@/types/activity-log.types';
import { BrandliveEvent } from '@/types/projects.types';
import { PayloadAction } from '@reduxjs/toolkit';
import { ProjectStateReducerCreator } from '../types';
import { Session } from '@/types/session.types';

const saveWorkingProjectReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer(
    (state, action: PayloadAction<{ project: BrandliveEvent; sessions?: Session[]; saveId?: string | null }>) => {
      // This update triggers in a debounce inside of save-project-middleware.ts
      state.savingWorkingProject = true;
      state.saveId = action.payload.saveId ?? state.saveId;
      state.workingProject = action.payload.project;
      // by adding sessionsToUpdateAfterProjectSave, save-project-middleware will update the session after the project is saved
      state.sessionsToUpdateAfterProjectSave = action.payload.sessions || null;

      // Update activity tracking
      state.mostRecentActivityLogUpdate = new Date().toISOString();
      state.mostRecentActivityLogType = IActivityTypes.events;
    }
  );
};

export default saveWorkingProjectReducer;
